<template>
  <div class="bottom-ui">
    <ul class="bottom-ui-btn">
      <li v-if="$parent.mirroringCurrentPage !== 1" class="prev-li"><button class="prev-btn" @click="$emit('prev')">{{$t('mirroring.prev')}}</button></li>
      <li v-if="$parent.mirroringCurrentPage !== $parent.mirroringTotalPage" class="next-li"><button class="next-btn" @click="$emit('next')">{{$t('mirroring.next')}}</button></li>
      <li v-else class="next-li"><button class="next-btn" @click="$emit('submit')">{{$t('mirroring.submit')}}</button></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RoomMirroringFooter',
}
</script>

<style lang="scss" scoped>
.bottom-ui {
  width: 100%;
}

.bottom-ui-btn {
  display: flex;
  height: 50px;

  .prev-li {
    width: 30%;
    height: 100%;
  }

  .next-li {
    flex: 1;
    height: 100%;
  }

  .prev-btn, .next-btn {
    width: 100%;
    height: inherit;
  }

  .prev-btn {
    background: #f1f1f1 url('~@/assets/images/arrowLineThickLeft.svg') no-repeat left 10px center / auto 24%;
    color: #666;
  }

  .next-btn {
    background: #016bff url('~@/assets/images/arrowLineThickRight_white.svg') no-repeat right 10px center / auto 24%;
    font-weight: bold;
    color: white;
  }
}
</style>